import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import ChainedBackend from 'i18next-chained-backend';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import { urls } from '@/config/urls';
import {
  defaultNamespace,
  fallbackLanguage,
  namespaces,
  supportedLocales,
} from './localeConfigs';

const remoteI18nUrl = urls.i18nApiUrl;

const backendOptions = remoteI18nUrl
  ? [
      {
        loadPath: `${remoteI18nUrl}?namespace={{ns}}&locale={{lng}}`,
      },
      {
        loadPath: '/locales/{{ns}}/{{lng}}.translation.json',
      },
    ]
  : [
      {
        loadPath: '/locales/{{ns}}/{{lng}}.translation.json',
      },
    ];

void i18n
  .use(ChainedBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    ns: namespaces,
    defaultNS: defaultNamespace,
    fallbackLng: fallbackLanguage,
    supportedLngs: supportedLocales as unknown as string[],
    load: 'currentOnly',
    backend: {
      backends: remoteI18nUrl ? [HttpBackend, HttpBackend] : [HttpBackend],
      backendOptions,
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export { i18n };
